import React from "react";
import { AppBar, Button } from '@mui/material'
import { Menu } from "@mui/icons-material";

const Header = () => {



  return (
    <AppBar sx={{ flexDirection: 'row', padding: 2, justifyContent: "space-between", position: 'sticky', backgroundColor: '#302E2EFF' }}>

      <img alt="" src="../../mjalogo.png" width={40} height={40} style={{ borderRadius: '50%', marginTop: 10, marginRight: 10 }}></img>
      <Button disableElevation startIcon={<Menu />} sx={{ fontSize: 11 }} href='#' color='#302E2EFF' variant='contained' size='large'></Button>
    </AppBar>

  );
};

export default Header;


